import { render, staticRenderFns } from "./create-profile-step-2.vue?vue&type=template&id=ad07f5aa"
import script from "./create-profile-step-2.vue?vue&type=script&lang=js"
export * from "./create-profile-step-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports